module.exports = __webpack_public_path__ + "static/media/closeEnvelope.60a3ffb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/closeEnvelope.svg
// module id = 448
// module chunks = 0